export function canOpenBookWithURL(url: string): boolean {
  return (
    /^\/?100\.\d{1,3}\.\d{1,3}.\d{1,3}/.test(url) ||
    /^\/?@\d+|@[^plwjv][a-z]{1,2}\d{4}$/.test(url)
  );
}
